import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import spinner from '../../../utility/json/Spinner.json';
import { setSessionExpired, setloading } from '../../../utility/Redux/modal';
import { selectTableMasterPrefix } from '../../../utility/Redux/profile';
import { selectToken } from '../../../utility/Redux/security';

import { FormatNumber2 } from '../tools';
import { CallAPIPromise } from '../../func/func';

const ItemMaster = (props) => {
  const { onRowClick } = props;
  const dispatch = useDispatch();
  const [searchText, SetSearchText] = useState('');
  const [filterdList, setFilteredList] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        field: 'item_name',
        type: 'string',
        width:
          window.innerWidth <= 1024
            ? (window.innerWidth / 100) * 10
            : (window.innerWidth / 100) * 12,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => <div>{'Item'}</div>,
      },
      {
        field: 'rate',
        type: 'number',
        width:
          window.innerWidth <= 1024
            ? (window.innerWidth / 100) * 10
            : (window.innerWidth / 100) * 6,
        headerAlign: 'center',

        align: 'right',
        valueFormatter: (params) => {
          if (params.value) {
            return FormatNumber2(params.value);
          } else {
            return '';
          }
        },
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => <div>{'Rate'}</div>,
      },
      {
        field: 'upper_lower',
        type: 'number',
        width:
          window.innerWidth <= 1024
            ? (window.innerWidth / 100) * 10
            : (window.innerWidth / 100) * 6,
        headerAlign: 'center',
        align: 'center',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => <div>{'Upper/Lower'}</div>,
      },
    ],
    []
  );
  const columnsMobile = React.useMemo(
    () => [
      {
        field: 'CODE',
        type: 'string',
        width: 150,
        headerAlign: 'center',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => <strong>{'Station Id'}</strong>,
      },
      {
        field: 'STATION_NAME',
        type: 'number',
        width: 100,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => <strong>{'Station Name'}</strong>,
      },
    ],
    []
  );
  const token = useSelector(selectToken);
  const masterPrifix = useSelector(selectTableMasterPrefix);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  const getCustomermasterList = () => {
    setloading(true);

    CallAPIPromise(`/api/masters/itemMasterHelp`, {
      table_prefix_master: masterPrifix,
      SECTION_NAME: 'Fabric',
    })
      .then((res) => {
        if (!res.data.error) {
          const data = res.data.response;

          setList(data);
        }
      })
      .catch((e) => {
        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(e);
      })
      .finally(() => {
        setloading(false);
      });
  };

  useEffect(() => {
    getCustomermasterList();
  }, []);

  useEffect(() => {
    if (searchText) {
      const regex = /\d+/;

      const searchItems = list.filter((item) => {
        if (regex.test(searchText.substring(0, 1))) {
          return item.icode.toString().includes(searchText);
        } else {
          return item.item_name
            .toLowerCase()
            .includes(searchText.toLowerCase());
        }
      });

      setFilteredList(searchItems);
    } else {
      setFilteredList('');
    }
  }, [searchText]);

  return (
    <div className="h-full w-full flex flex-col ">
      <div className="flex flex-col grow">
        {loading ? (
          <div className="w-full   flex justify-center items-center  ">
            <div className="w-6 h-6">
              <Lottie
                animationData={spinner}
                loop={true}
                style={{ fontSize: 15 }}
                color="white"
              />
            </div>
          </div>
        ) : (
          <DataGrid
            hideFooterPagination
            hideFooter
            onRowClick={onRowClick}
            headerHeight={0}
            getRowId={(param) => param.icode}
            components={{
              Header: () => {
                const headerDetails =
                  window.innerWidth < 770 ? columnsMobile : columns;
                return (
                  <div className="  bg-[#f5f0e8] flex ">
                    {headerDetails?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="  text-black flex justify-center items-center py-2  "
                          style={
                            item.flex
                              ? index < headerDetails.length - 1
                                ? {
                                    flex: item.flex,
                                    borderRight: '1px solid black',
                                    borderBottom: '1px solid black',

                                    // borderTop: '1px solid #4a4948',
                                  }
                                : {
                                    flex: item.flex,

                                    borderBottom: '1px solid black',
                                  }
                              : index < headerDetails.length - 1
                              ? {
                                  width: item.width,

                                  borderRight: '1px solid gray',
                                  borderBottom: '1px solid gray',
                                  // border: '1px solid black',
                                  // borderTop: '1px solid black',
                                }
                              : {
                                  width: item.width,
                                  borderBottom: '1px solid black',
                                }
                          }
                        >
                          {item.renderHeader()}
                        </div>
                      );
                    })}
                  </div>
                );
              },
            }}
            sx={
              window.innerWidth < 770
                ? {
                    backgroundColor: 'white',

                    fontSize: 9,
                    '& .super-app-theme--header': {
                      backgroundColor: '#f5f0e8',
                      borderRight: `1px solid #4a4948`,
                      display: 'none',
                    },
                    borderLeft: '1px solid black',
                    borderRight: '1px solid black',
                    borderRadius: '0px',
                  }
                : {
                    backgroundColor: 'white',

                    fontSize: 13,
                    borderLeft: '1px solid black',
                    borderRight: '1px solid black',

                    borderRadius: '0px',

                    '& .MuiDataGrid-cell': {
                      borderRight: `1px solid #918f8d`,
                      borderBottom: `1px solid #918f8d`, // Customize border color here
                    },

                    '& .super-app-theme--header': {
                      backgroundColor: '#f5f0e8',
                      borderRight: `1px solid #4a4948`,
                      display: 'none',
                    },
                  }
            }
            rowHeight={33}
            columns={window.innerWidth < 770 ? columnsMobile : columns}
            rows={filterdList[0] ? filterdList : list}
            pageSize={100}
            rowsPerPageOptions={[100]}
            experimentalFeatures={{ newEditingApi: true }}
            showCellRightBorder={true}
            showColumnRightBorder={true}
            disableColumnSelector
            disableColumnReorder
            disableColumnMenu={true}
          />
        )}
      </div>

      <div
        style={{
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          borderBottom: '0px solid #4a4948',
          borderTop: '1px solid #4a4948',
          fontSize: '14px',
          backgroundColor: '#f5f0e8',
        }}
        className="flex p-2 "
      >
        <i className="bi bi-search pr-2"></i>
        <input
          ref={inputRef}
          type={'text'}
          placeholder="Search"
          value={searchText}
          onChange={(t) => {
            SetSearchText(t.target.value);
          }}
          className="w-full outline-0 bg-[#f5f0e8]"
        />
      </div>
    </div>
  );
};

export default ItemMaster;
